exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs5-quick-links[data-v-7ed6932f]{font:inherit}.fs5-quick-links .fs5-quick-links-button[data-v-7ed6932f]{font:inherit;display:grid;grid-template-columns:repeat(auto-fit,minmax(10px,1fr));grid-template-rows:auto;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-column-gap:1.8em;-moz-column-gap:1.8em;column-gap:1.8em}@media screen and (max-width:500px){.fs5-quick-links .fs5-quick-links-button[data-v-7ed6932f]{grid-template-columns:1fr;row-gap:1em}.fs5-quick-links .fs5-quick-links-button[data-v-7ed6932f]:last-child{margin-top:1em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ed6932f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/franchise_v5/affiliate_dashboard/quick_links/index.vue
// module id = HQdP
// module chunks = 0